import React, { Component } from "react";
import { connect } from "react-redux";
import { EditOrganizationDialog } from "../dialogs/EditOrganizationDialog";
import { mapKV } from "../utils/map";
import { editOrganization } from "../redux/actions/organizationActions";

export class EditOrganization extends Component {
  state = {
    name: "",
    nameNotUnique: false,
    saveAvaliable: true,
    reportLinkID: ""
  };

  componentDidMount() {
    const { selectedKey, organizations } = this.props;
    const { name, reportLinkID="" } = organizations[selectedKey];
    this.setState({ name, reportLinkID });
  }

  onNameChange = name => this.setState({ name }, this.checkSaveAvaliable);

  onReportLinkIDChange = reportLinkID => this.setState({ reportLinkID });

  checkSaveAvaliable = () => {
    const { name } = this.state;
    const { organizations, selectedKey } = this.props;
    let nameNotUnique = false;
    mapKV(organizations, (k, v) => {
      if (k === selectedKey) return;
      if (name.trim() === v.name) nameNotUnique = true;
    });

    this.setState({ nameNotUnique });

    let saveAvaliable = true;
    if (nameNotUnique || name === "") saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  onSave = () => {
    const { name, reportLinkID } = this.state;
    const { editOrganization, onClose, selectedKey } = this.props;
    editOrganization({ key: selectedKey, name, reportLinkID });
    onClose();
  };

  render() {
    const { onClose, organizations, selectedKey } = this.props;
    const { name, nameNotUnique, saveAvaliable, reportLinkID } = this.state;

    return (
      <EditOrganizationDialog
        currentOrganization={organizations[selectedKey]}
        onClose={onClose}
        name={name}
        onNameChange={this.onNameChange}
        nameNotUnique={nameNotUnique}
        saveAvaliable={saveAvaliable}
        onSave={this.onSave}
        reportLinkID={reportLinkID}
        onReportLinkIDChange={this.onReportLinkIDChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  organizations: state.data.organizations
});

const mapDispatchToProps = { editOrganization };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditOrganization);
